import { useSelectedChildEligibility } from '@hooks/context/use-account-application-context';
import { useGuaranteedSession } from '@hooks/use-guaranteed-session';
import { useLinks } from '@hooks/use-links';
import { useProcessRole } from '@hooks/use-process-role';
import { useProcess } from '@react-query/hooks/query/use-process';
import { isComplete } from '@utils/process-utils';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useNavigateHomeIfNoChildSelected = () => {
    const selectedChildEligibility = useSelectedChildEligibility();
    const navigate = useNavigate();

    useEffect(() => {
        if (!selectedChildEligibility) {
            navigate('/', { replace: true });
        }
    }, [selectedChildEligibility, navigate]);
};

export const useNavigateIfInappropriateApproveAttempt = () => {
    const { data: process, isSuccess } = useProcess();
    const { fnr } = useGuaranteedSession();
    const navigate = useNavigate();
    const { process: processLink } = useLinks();
    const { hasApproverRole } = useProcessRole(process);

    useEffect(() => {
        if (!isSuccess || !process) {
            return;
        }

        if (isComplete(process)) {
            navigate(`${processLink.url}/${process.id}`, { replace: true });
            return;
        }

        if (!hasApproverRole) {
            navigate('/', { replace: true });
        }
    }, [isSuccess, process, fnr, navigate, processLink]);
};
